import React from "react";

/**
 * Render either a sanitized HTML body (when an inbound email arrived as HTML)
 * or the plain-text fallback. Backend has already run bleach.clean() so we
 * can safely inject via dangerouslySetInnerHTML.
 *
 * Usage:
 *   <EmailBody text={ticket.message} html={ticket.message_html} />
 *   <EmailBody text={reply.body}      html={reply.body_html} />
 */
export function EmailBody({ text, html, className = "" }) {
  if (html && html.trim()) {
    return (
      <div
        data-testid="email-body-html"
        className={`email-html-body max-w-none text-sm text-slate-800 leading-relaxed ${className}`}
        // Backend sanitizes with bleach before this ever hits the client.
        dangerouslySetInnerHTML={{ __html: html }}
      />
    );
  }
  return (
    <p
      data-testid="email-body-text"
      className={`text-sm text-slate-800 whitespace-pre-wrap leading-relaxed ${className}`}
    >
      {text || ""}
    </p>
  );
}

export default EmailBody;
